import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import {
  getJiraTwoWayUrl,
  GetJiraTwoWayUrlArgs
} from './requests/get-jira-two-way-url'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseJiraTwoWayUrlQueryProps {
  organizationUuid: string
  integration: boolean
  bugtrackerId?: number
}

export interface JiraTwoWayUrlQueryResponse {
  url?: string
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseJiraTwoWayUrlQuery = (
  props: UseJiraTwoWayUrlQueryProps
) => JiraTwoWayUrlQueryResponse

export const useJiraTwoWayUrlQuery: UseJiraTwoWayUrlQuery = ({
  organizationUuid,
  integration,
  bugtrackerId
}: UseJiraTwoWayUrlQueryProps) => {
  const {
    data: url,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetJiraTwoWayUrlArgs, string>(
    [Query.INTEGRATIONS_TWO_WAY_URL_JIRA, organizationUuid, bugtrackerId],
    getJiraTwoWayUrl,
    {
      organizationUuid,
      bugtrackerId
    },
    {
      enabled: !!integration,
      cacheTime: 0 // need to always reload when a new Jira integration is created
    }
  )

  return {
    url,
    error,
    isError,
    isLoading
  }
}
